'use client'

import { Checkbox } from '@/ui/components'
import { ChangeEvent, useEffect, useRef, useState } from 'react'

const CheckboxGroup = ({
  options,
  required,
  onChange,
  onRadioChange,
  name,
  id,
  ...props
}: {
  options: { name: string; value: string; label: string }[]
  required?: boolean
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void
  onRadioChange?: (e: ChangeEvent<HTMLInputElement>) => void
  id?: string
  name?: string
  [key: string]: any
}) => {
  const fieldsetRef = useRef<HTMLFieldSetElement>(null)
  const inputRefs = useRef<HTMLInputElement[]>([])
  const [checked, setChecked] = useState(false)

  useEffect(() => {
    inputRefs.current = inputRefs.current.filter((ref) => ref !== null)
  }, [options])

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (fieldsetRef.current) {
      const hasChecked = inputRefs.current.some((ref) => ref.checked)
      setChecked(hasChecked)
    }
    onChange?.(e)
  }

  const radioChange = (e: ChangeEvent<HTMLInputElement>) => {
    onRadioChange?.(e)
  }

  return (
    <>
      <fieldset
        ref={fieldsetRef}
        id={'checkbox-group-' + id}
        className="gap-xs flex flex-col"
      >
        {options.map((option: any, index: number) => (
          <Checkbox
            key={option.value}
            name={option.name || name}
            id={option.name + '-' + index.toString()}
            label={option.label}
            value={option.value}
            onChange={(e) => handleChange(e)}
            ref={(el) => {
              if (el) {
                inputRefs.current[index] = el
              }
            }}
          />
        ))}
      </fieldset>
      <input
        type="radio"
        className="hidden"
        name={'fake-input-' + name}
        required={required}
        checked={checked}
        value={'-'}
        onChange={(e) => radioChange(e)}
        {...props}
      />
    </>
  )
}

export default CheckboxGroup
